"use client";

import { Card, Table } from "react-bootstrap";
import { FILES_BASE_URL } from "../../../config";
import { formatCurrency } from "../../../utils";

interface RecentOrdersProps {
  order: any;
}

const RecentOrders = ({ order }: RecentOrdersProps) => {
  return (
    <>
      <Card className="bg-white border-0 rounded-3 mb-4">
        <Card.Body className="p-4">
          <h3 className="mb-3 mb-lg-4">Productos de la Orden</h3>

          <div className="default-table-area">
            <div className="table-responsive">
              <Table className="table align-middle">
                <thead>
                  <tr>
                    <th scope="col">Producto</th>
                    <th scope="col">Puntos</th>
                    <th scope="col">Cantidad</th>
                    <th scope="col">Precio</th>
                    <th scope="col">Subtotal</th>
                  </tr>
                </thead>

                <tbody>
                  {order?.items?.map((item: any, index: number) => (
                    <tr key={index}>
                      <td>
                        <div className="d-flex align-items-center">
                          {item.product_id.images && item.product_id.images.length > 0 && (
                            <div className="flex-shrink-0 me-3">
                              <img
                                src={`${FILES_BASE_URL}/${item.product_id.images[0]}`}
                                alt={item.product_id.title}
                                width={50}
                                height={50}
                                className="rounded"
                                onError={(e) => {
                                  (e.target as HTMLImageElement).src = '/images/placeholder-product.png';
                                }}
                              />
                            </div>
                          )}
                          <div>
                            <h6 className="mb-1">{item.product_id.title}</h6>
                            <small className="text-muted">
                              País: {item.product_id.aditionalData?.[0]?.country_id?.name}
                            </small>
                          </div>
                        </div>
                      </td>
                      <td>
                        <span className="text-success">{item.loyalty_points * item.quantity} pts</span>
                      </td>
                      <td>
                        <span className="badge bg-primary">{item.quantity}</span>
                      </td>
                      <td>
                        <strong>{formatCurrency(item.price, order.currency ?? 'COP')}</strong>
                      </td>

                      <td>
                        <span className="text-info">{formatCurrency(item.price * item.quantity, order.currency ?? 'COP')}</span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </div>

          {order?.items && order.items.length > 0 && (
            <div className="mt-3">
              <div className="d-flex justify-content-between">
                <span>Tiempo de entrega estimado:</span>
                <span className="fw-medium">
                  {order.items[0]?.product_id?.aditionalData?.[0]?.delivery_time_days} días
                </span>
              </div>
            </div>
          )}
        </Card.Body>
      </Card>
    </>
  );
};

export default RecentOrders;
